import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useLanguage } from '../contexts/LanguageContext';
import { ASSETS } from '../components/Navbar';
import { Loader2 } from 'lucide-react';

const AuthCallback = () => {
  const navigate = useNavigate();
  const { exchangeSession } = useAuth();
  const { t } = useLanguage();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      const hash = window.location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      
      if (!sessionIdMatch) {
        console.error('No session_id found in URL');
        navigate('/login');
        return;
      }

      const sessionId = sessionIdMatch[1];

      try {
        const user = await exchangeSession(sessionId);
        if (user.application_status === 'approved') {
          navigate('/dashboard', { state: { user } });
        } else if (user.application_status === 'pending') {
          navigate('/application-status', { state: { user } });
        } else {
          navigate('/apply', { state: { user } });
        }
      } catch (error) {
        console.error('Auth error:', error);
        navigate('/login');
      }
    };

    processAuth();
  }, [exchangeSession, navigate]);

  return (
    <div className="min-h-screen bg-[#0B0B0B] flex items-center justify-center">
      <div className="text-center">
        <img 
          src={ASSETS.logo}
          alt="Soul Mate Dates"
          className="w-20 h-20 mx-auto mb-8 logo-glow object-contain"
        />
        <Loader2 className="w-8 h-8 mx-auto text-[#8B1A1A] animate-spin mb-4" />
        <p className="text-[#8A8A8A]">{t('auth_verifying')}</p>
      </div>
    </div>
  );
};

export default AuthCallback;
